import { ProjectCostCodeCostTypeItemsRevisionBase } from './base/project-cost-code-cost-type-items-revision-base';

export class ProjectCostCodeCostTypeItemsRevision extends ProjectCostCodeCostTypeItemsRevisionBase { }